export const environment = {
  production: false,
  hmr: false,
  googleTagManager: {
    containerId: 'GTM-PXNB9DCH'
  },
  apiUrl: 'https://api-dev.app-npe.mybenefits.ro',
  benAiUrl: 'https://benai.app-npe.mybenefits.ro',
  googleAnalyticsTag: 'G-67MDJ567RV',
  sso: {
    authorizationUrl: 'https://mybenefitsdemosso.b2clogin.com/mybenefitsdemosso.onmicrosoft.com/oauth2/v2.0/authorize',
    policyId: 'B2C_1_SuSi_Demo',
    clientId: '45f33df9-5a1b-4904-8b1e-947104bdf303',
    mobileRedirectUrl: 'https://flexben-dev.app-npe.mybenefits.ro'
  },
  selfService: {
    enabled: true,
    matcher: '.*',
    url: 'https://admin-dev.app-npe.mybenefits.ro/auth/jump'
  },
  taxManagement: {
    "hideTaxesFor": [94]
  },
  MAX_TOTAL_FILE_SIZE_MB: 10,
  MAX_IMAGE_SIZE_MB: 5,
  MAX_IMAGE_WIDTH: 1280,
  MAX_IMAGE_HEIGHT: 1280,
  MAX_DOCUMENT_SIZE_MB: 5,
  FAQ_URL: 'https://www.pluxee.ro/helpcenter/angajat/platforma-mybenefits/',
  benAiGuidelinesUrl: 'https://storage.googleapis.com/mybenefits-assets/benai/dev/Benny%20AI%20Guidelines%20for%20use%20-%20v2.pdf',
  cookiesPolicyUrl: 'https://storage.googleapis.com/mybenefits-assets/dev/Fake%20cookie%20policy.pdf',
  speakUpPolicyUrl: 'random url',
  privacyPolicyPrevVersion: ''
};
